import { useCustomFetch } from "../hooks";

export function FetchCustom() {
    return useCustomFetch();
}